import { Component, inject, input } from '@angular/core'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { Customer } from 'src/app/shared/interfaces/customer/customer.interface'
import { SmartQuote } from 'src/app/shared/interfaces/smartquote/smart-quote.interface'
import { SmartQuoteStatistics } from 'src/app/shared/interfaces/smartquote/smartquote-statistics.interface'
import { SmartQuoteCalculations } from '../../../smartquote-calculations.interface'
import { CurrencyPipe } from '@angular/common'
import { ButtonComponent } from 'src/app/shared/components/form-elements/button/button.component'
import { SmartquoteHelperService } from '../../../services/smartquote-helper.service'
import { RouterLink } from '@angular/router'

@Component({
    selector: 'sf-smartquote-summary',
    imports: [RouterLink, FontAwesomeModule, ButtonComponent, CurrencyPipe],
    templateUrl: './smartquote-summary.component.html',
    styleUrl: './smartquote-summary.component.scss',
    host: {
        class: 'd-block mt-3',
    },
})
export class SmartquoteSummaryComponent {
    smartquoteHelperService = inject(SmartquoteHelperService)

    quote = input<SmartQuote | null>()
    customer = input<Customer | null>()
    workAddress = input<string | null>()
    freeOfCharge = input<boolean>(false)

    statistics = input.required<SmartQuoteCalculations>()
}
